"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of {@link BranchMappingTable}.
 */
var BranchMappingTableImpl = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param sessionTreeBranch the branch of the session tree to which this table is bound
     * @param branchMappings the branch mappings
     */
    function BranchMappingTableImpl(sessionTreeBranch, branchMappings) {
        this.sessionTreeBranch = sessionTreeBranch;
        this.branchMappings = branchMappings;
    }
    /**
     * @inheritdoc
     */
    BranchMappingTableImpl.prototype.getSessionTreeBranch = function () {
        return this.sessionTreeBranch;
    };
    /**
     * @inheritdoc
     */
    BranchMappingTableImpl.prototype.getBranchMappings = function () {
        return this.branchMappings;
    };
    return BranchMappingTableImpl;
}());
exports.BranchMappingTableImpl = BranchMappingTableImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/session-trees/branch-mapping-table.js
// module id = 523
// module chunks = 1